<template>
    <div class="home-page-news" v-if="!loading && !error && news.length > 0">
        <h2 v-if="title" class="insights__section-title">
            {{ title }}
        </h2>
        <div class="tagged-news__container">
            <div class="tagged-news__section">
                <template v-for="(item, index) in news.slice(0, featured.length > 0 ? 1 : 2)">
                    <a v-if="!['Video', 'Podcast'].includes(item.modelType)" :href="item.url" :class="`tagged-news ${item.featuredImageUrl
                        ? 'news-block--image' : ''}`"
                        :style="`background-image: url('${item.featuredImageUrl ? item.featuredImageUrl : ''}')`"
                        :key="`left-${index}`">
                        <div class="news-block__inner" :class="{
                            'news-block__inner-with-title': item.tilesCategory || item.tilesCategoryOverwrite
                        }" :style="`${item.disableGradientOverlay ? 'background-image: none !important;' : ''}`">
                            <div class="tagged-news__content">
                                <h6 v-if="item.tilesCategoryOverwrite" class="tagged-news__category">{{
                                    item.tilesCategoryOverwrite }}</h6>
                                <h6 v-else-if="item.tilesCategory" class="tagged-news__category">{{ item.tilesCategory }}
                                </h6>
                                <h3 class="tagged-news__title news-block__title">{{ item.title }}</h3>
                            </div>
                            <div class="tagged-news__meta">
                                <span>{{ item.category }}</span><span v-if="!item.hideDate">{{ item.published }}</span>
                            </div>
                        </div>
                    </a>

                    <InsightsBlock v-else :disableNavigationOnClick="item.disableNavigationOnClick"
                        :disableGradientOverlay="item.disableGradientOverlay" :category="item.category" :url="item.url"
                        :featuredImageUrl="item.featuredImageUrl" :title="item.title" :type="item.modelType"
                        :published="item.published" :podcast-embed-url="item.podcastEmbedUrl"
                        :tilesCategory="item.tilesCategory" :tilesCategoryOverwrite="item.tilesCategoryOverwrite"
                        :hideDate="item.hideDate" :video-embed-url="item.videoEmbedUrl" />
                </template>

                <FeaturedSliderCard v-show="featured.length > 0" :featured="featured"></FeaturedSliderCard>
            </div>
            <div class="tagged-news__section">
                <template v-for="(item, index) in news.slice(featured.length > 0 ? 1 : 2, featured.length > 0 ? 4 : 5)">
                    <a v-if="!['Video', 'Podcast'].includes(item.modelType)" :href="item.url" :class="`tagged-news ${item.featuredImageUrl
                        ? 'news-block--image' : ''}`"
                        :style="`background-image: url('${item.featuredImageUrl ? item.featuredImageUrl : ''}')`"
                        :key="`right-${index}`">
                        <div class="news-block__inner" :class="{
                            'news-block__inner-with-title': item.tilesCategory || item.tilesCategoryOverwrite
                        }" :style="`${item.disableGradientOverlay ? 'background-image: none !important;' : ''}`">
                            <div class="tagged-news__content">
                                <h6 v-if="item.tilesCategoryOverwrite" class="tagged-news__category">{{
                                    item.tilesCategoryOverwrite }}</h6>
                                <h6 v-else-if="item.tilesCategory" class="tagged-news__category">{{ item.tilesCategory }}
                                </h6>
                                <h3 class="tagged-news__title news-block__title">{{ item.title }}</h3>
                            </div>
                            <div class="tagged-news__meta">
                                <span>{{ item.category }}</span><span v-if="!item.hideDate">{{ item.published }}</span>
                            </div>
                        </div>
                    </a>

                    <InsightsBlock v-else :disableNavigationOnClick="item.disableNavigationOnClick"
                        :disableGradientOverlay="item.disableGradientOverlay" :category="item.category" :url="item.url"
                        :featuredImageUrl="item.featuredImageUrl" :title="item.title" :type="item.modelType"
                        :published="item.published" :podcast-embed-url="item.podcastEmbedUrl"
                        :tilesCategory="item.tilesCategory" :tilesCategoryOverwrite="item.tilesCategoryOverwrite"
                        :hideDate="item.hideDate" :video-embed-url="item.videoEmbedUrl" />
                </template>
            </div>
        </div>
        <div class="news-block__grid">
            <div class="news-block__grid-wrapper">
                <a v-for="(article, index) in news.slice(featured.length > 0 ? 4 : 5, (news.length > 20 ? 20 : news.length))"
                    :key="index + '-regular'" :href="article.url" class="news-block__grid-item">
                    <div class="news-block__grid-meta">
                        <span>{{ article.category }}</span><span>
                            {{
                                article.published
                            }}
                        </span>
                    </div>
                    <h3 class="news-block__grid-title">{{ article.title }}</h3>
                </a>
            </div>
        </div>
        <div class="news-block__button">
            <a :href="newsUrl" class="button">View all News</a>
            <a :href="insightsUrl" class="button">View all Insights</a>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import FeaturedSliderCard from "./FeaturedSliderCard"
import InsightsBlock from "../Insights/InsightsBlock";

export default {
    props: ["title", "featured", "featuredContent"],
    components: {
        FeaturedSliderCard,
        InsightsBlock
    },
    data() {
        return {
            error: false,
            loading: true,
            newsUrl: "/news",
            insightsUrl: "/insights",
            news: [],
            sorted: {
                left: [],
                right: [],
                other: [],
            },
        }
    },
    mounted() {
        this.getRelatedContent();
    },
    watch: {
        news() {
            this.sorted = {
                left: [],
                right: [],
                other: [],
            };
            let left = [];
            let right = [];
            let other = [];
            this.news.forEach((item, index) => {
                if (index < 2) {
                    left.push(item);
                } else if (index < 5) {
                    right.push(item);
                } else {
                    other.push(item);
                }
            });
            this.sorted.left = left;
            this.sorted.right = right;
            this.sorted.other = other;
        }
    },
    methods: {
        getRelatedContent: function () {
            axios.post("/api/news/home", this.featuredContent, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.newsUrl = response.data.newsUrl;
                    this.news = response.data.news;
                    this.loading = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                });
        }
    }
}
</script>

